import {Fragment} from "preact";
import {useLocationPickerModal} from "./useLocationPickerModal";
import {Dialog, Transition} from "@headlessui/react";
import s from "./locationPickerModal.module.css";
import Content from "./Content";

const LocationPickerModal = () => {
    // Component logic data
    const componentProps = useLocationPickerModal();

    // Destructured component logic data
    const {
        isOpen,
        handleClose
    } = componentProps;

    return (
        <Fragment>
            <Transition.Root show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[20]" onClose={handleClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-fade-modal bg-opacity-75 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center text-center sm:items-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-700"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-300"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel
                                    className={`relative transform overflow-hidden h-screen bg-light-gray px-4 md:px-8 py-6 text-left shadow-xl transition-all sm:max-w-screen sm:p-6 w-screen flex items-start md:items-center ${s.root}`}>
                                        <div className={`px-4 w-full max-w-full md:max-w-[1140px] mx-auto`}>
                                            <Content />
                                        </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Fragment>
    )
}

export default LocationPickerModal;
